// extracted by mini-css-extract-plugin
export default {"Nav":"nav_Nav__ESz5A"};